import { Component, OnInit, ViewChild, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-modaldisclaimer',
  templateUrl: './modaldisclaimer.component.html',
  styleUrls: ['./modaldisclaimer.component.css']
})
export class ModaldisclaimerComponent implements OnInit, OnChanges {
  @ViewChild('myModel') myModal;
  @Input() selectedevent: any = {};
  selecteddrugname: String;
  constructor() {
    console.log(this.myModal);
  }

  ngOnInit() {
    console.log('modalDisclaimer');
    console.log(this.myModal);
  }
  openModel() {
    console.log(this.myModal);
    this.myModal.nativeElement.className = 'modal fade show';
  }
  ngOnChanges() {
    this.selecteddrugname = this.selectedevent;
  }
  closeModel() {
    console.log(this.myModal);
    this.myModal.nativeElement.className = 'modal hide';
  }
}
